module.exports = __webpack_public_path__ + "static/media/menu.5a6744dd.svg";